<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up dashboard-shell" :loading="loading" flat>
          <v-card-text class="pa-0">
            <v-container fluid>
              <v-row justify="end" align="center" class="px-4 pt-4">
                <v-col cols="12" md="4" class="d-flex align-center">
                  <v-text-field
                    v-model="searchPersonal"
                    label="Buscar personal por nombre"
                    class="ui-form-field flex-grow-1"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="ml-2">
                        <IconButton variant="secondary" icon="mdi-download" @click="descargarCsv" />
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                    :headers="headers"
                    :items="filteredPersonal"
                    class="transparent ui-module-table no-table-bg"
                    :loading="loading"
                  >
                    <template v-slot:[`item.nombre`]="{ item }">
                      <div class="d-inline-flex align-center pt-4">
                        <v-avatar size="48" class="mr-4">
                          <v-img :src="item.foto"></v-img>
                        </v-avatar>
                        <div>
                          <div class="text-caption font-weight-bold">
                            {{ getFullName(item) }}
                          </div>
                          <div class="text-caption">
                            {{ item.CUIP }}
                          </div>
                          <div class="text-caption" v-if="item.CatPuestoDependencia">
                            {{ item.puesto }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.susceptible`]="{ item }">
                      <v-icon v-if="susceptibleCup(item)" color="success">mdi-check-circle</v-icon>
                      <v-icon v-else color="error">mdi-alert-circle</v-icon>
                    </template>
                    <template v-slot:[`item.vigenciaEvaluacionC3`]="{ item }">
                      {{ formatFechaAjustada(obtenerFechaVigencia(item, 'vigenciaEvaluacionC3')) }}
                    </template>
                    <template v-slot:[`item.vigenciaFormacionInicial`]="{ item }">
                      {{ formatFechaAjustada(obtenerFechaVigencia(item, 'vigenciaFormacionInicial')) }}
                    </template>
                    <template v-slot:[`item.vigenciaCompetenciasBasicas`]="{ item }">
                      {{ formatFechaAjustada(obtenerFechaVigencia(item, 'vigenciaCompetenciasBasicas')) }}
                    </template>
                    <template v-slot:[`item.vigenciaCup`]="{ item }">
                      {{ formatFechaAjustada(obtenerFechaVigencia(item, 'vigenciaCup')) }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import IconButton from '@/components/base/IconButton.vue'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    IconButton,
  },
  async mounted() {
    this.loading = true
    // Configurar locale de moment a español para manejar fechas correctamente
    moment.locale('es')

    if (this.personal.length == 0) {
      // await this.fetchPersonalPagination({
      //     page: this.options.page,
      //     rows: this.options.itemsPerPage,
      // })
      await this.fetchPersonalByDependencia(1)
    }
    this.loading = false
  },

  data() {
    return {
      loading: false,
      searchPersonal: '',

      headers: [
        { text: 'Nombre', value: 'nombre', sortable: false, align: 'left' },
        { text: 'Susceptible a CUP', value: 'susceptible', align: 'center', sortable: false },
        { text: 'Vigencia C3', value: 'vigenciaEvaluacionC3', align: 'center', sortable: false },
        { text: 'Vigencia Formación Inicial', value: 'vigenciaFormacionInicial', align: 'center', sortable: false },
        { text: 'Vigencia Comp. Básicas', value: 'vigenciaCompetenciasBasicas', align: 'center', sortable: false },
        { text: 'Vigencia CUP', value: 'vigenciaCup', align: 'center', sortable: false },
      ],
      options: {
        page: 1,
        itemsPerPage: 5,
      },
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getFullPersonal',
    }),

    filteredPersonal() {
      if (this.personal.length > 0) {
        const search = this.searchPersonal.toLowerCase()
        return this.personal.filter((elemento) => {
          return this.getFullName(elemento).toLowerCase().indexOf(search) >= 0
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalPagination', 'fetchPersonalByDependencia']),

    descargarCsv() {
      const data = this.filteredPersonal.map((item) => ({
        Nombre: this.getFullName(item),
        CUIP: item.CUIP || '',
        'Susceptible CUP': this.susceptibleCup(item) ? 'Sí' : 'No',
        'Vigencia C3': this.formatFechaAjustada(this.obtenerFechaVigencia(item, 'vigenciaEvaluacionC3')),
        'Vigencia Formación Inicial': this.formatFechaAjustada(this.obtenerFechaVigencia(item, 'vigenciaFormacionInicial')),
        'Vigencia Comp. Básicas': this.formatFechaAjustada(this.obtenerFechaVigencia(item, 'vigenciaCompetenciasBasicas')),
        'Vigencia CUP': this.formatFechaAjustada(this.obtenerFechaVigencia(item, 'vigenciaCup')),
      }))
      downloadCsv(data, { filename: 'desarrollo-profesional' })
    },

    /**
     * Valida si el personal es susceptible a CUP
     * Requiere que todas las vigencias estén vigentes
     */
    susceptibleCup(personal) {
      const vigenciaEvaluacionC3 = this.obtenerFechaVigencia(personal, 'vigenciaEvaluacionC3')
      const vigenciaFormacionInicial = this.obtenerFechaVigencia(personal, 'vigenciaFormacionInicial')
      const vigenciaCompetenciasBasicas = this.obtenerFechaVigencia(personal, 'vigenciaCompetenciasBasicas')
      const vigenciaCup = this.obtenerFechaVigencia(personal, 'vigenciaCup')

      if (
        this.tieneC3Vigente(vigenciaEvaluacionC3) &&
        this.tieneC3Vigente(vigenciaFormacionInicial) &&
        this.tieneC3Vigente(vigenciaCompetenciasBasicas) &&
        this.tieneC3Vigente(vigenciaCup)
      ) {
        return true
      } else return false
    },

    /**
     * Construye el nombre completo del personal
     */
    getFullName(personal) {
      if (!personal) return ''
      const nombre = personal.nombre || ''
      const segundoNombre = personal.segundoNombre || ''
      const apaterno = personal.apaterno || ''
      const amaterno = personal.amaterno || ''

      return `${apaterno} ${amaterno} ${nombre} ${segundoNombre}`.replace(/\s+/g, ' ').trim()
    },

    /**
     * Valida si la vigencia ajustada es válida (no centinela y no expirada)
     */
    tieneC3Vigente(fecha) {
      if (this.esFechaCentinela(fecha)) return false

      const fechaAjustada = this.getFechaVigenciaAjustada(fecha)
      if (!fechaAjustada) return false

      const fechaMoment = moment(fechaAjustada, 'YYYY-MM-DD', true)
      const ahora = moment()

      // Retorna true si la fecha ajustada es igual o mayor a hoy
      return fechaMoment.isSameOrAfter(ahora, 'day')
    },

    /**
     * Verifica si una fecha es centinela (sin fecha registrada)
     */
    esFechaCentinela(fecha) {
      if (!fecha) return true
      const rawFecha = String(fecha).trim()
      if (!rawFecha) return true
      return rawFecha.startsWith('1900-01-01') || rawFecha.startsWith('01/01/1900')
    },

    /**
     * Obtiene la fecha de vigencia del personal desde el objeto item
     * Intenta múltiples nombres de campo para mayor compatibilidad
     */
    obtenerFechaVigencia(item, campo) {
      const campoAlterno = {
        vigenciaEvaluacionC3: ['vigenciaEvaluacionC3', 'fechaVigenciaEvaluacionC3', 'vigencia_c3'],
        vigenciaFormacionInicial: ['vigenciaFormacionInicial', 'fechaVigenciaFormacionInicial'],
        vigenciaCompetenciasBasicas: ['vigenciaCompetenciasBasicas', 'fechaVigenciaCompetenciasBasicas'],
        vigenciaCup: ['vigenciaCup', 'fechaVigenciaCup'],
      }

      const keys = campoAlterno[campo] || [campo]

      // Busca la primera clave que exista y tenga un valor
      for (let key of keys) {
        const valor = item?.[key]
        if (valor && typeof valor === 'string' && valor.trim()) {
          return valor.trim()
        }
      }

      // Si no encuentra nada, retorna cadena vacía
      return ''
    },

    /**
     * Calcula la fecha ajustada sumando 3 años a la fecha original
     * Detecta automáticamente el formato de entrada (YYYY-MM-DD o DD/MM/YYYY)
     */
    getFechaVigenciaAjustada(fecha) {
      if (!fecha) return null

      const rawFecha = String(fecha).trim()
      if (!rawFecha) return null

      // Valores centinela de "sin fecha"; no deben convertirse a 1900.
      if (this.esFechaCentinela(rawFecha)) return null

      const fechaSinHora = rawFecha.includes('T') ? rawFecha.split('T')[0] : rawFecha.substring(0, 10)

      let fechaMoment = null

      // Detectar formato e intentar parsear
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fechaSinHora)) {
        // Formato DD/MM/YYYY
        const partes = fechaSinHora.split('/')
        const dia = parseInt(partes[0], 10)
        const mes = parseInt(partes[1], 10)
        const anio = parseInt(partes[2], 10)

        // Crear momento directamente con parámetros
        fechaMoment = moment([anio, mes - 1, dia]) // mes es 0-indexed en moment

        if (!fechaMoment.isValid()) {
          // Intentar con formato string como fallback
          fechaMoment = moment(fechaSinHora, 'DD/MM/YYYY', true)
        }
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(fechaSinHora)) {
        // Formato YYYY-MM-DD
        fechaMoment = moment(fechaSinHora, 'YYYY-MM-DD', true)
      } else {
        // Intenta ambos formatos sin strict
        fechaMoment = moment(fechaSinHora, ['DD/MM/YYYY', 'YYYY-MM-DD'])
      }

      if (!fechaMoment || !fechaMoment.isValid()) {
        console.warn(`Fecha inválida: ${fecha}, rawFecha: ${rawFecha}`)
        return null
      }

      return fechaMoment.add(3, 'years').format('YYYY-MM-DD')
    },

    /**
     * Formatea la fecha ajustada para mostrar en la UI
     * Retorna 'No registrada' si no hay fecha válida
     */
    formatFechaAjustada(fecha) {
      if (!fecha || !String(fecha).trim()) {
        return 'No registrada'
      }

      const fechaAjustada = this.getFechaVigenciaAjustada(fecha)
      if (!fechaAjustada) {
        return 'No registrada'
      }

      return moment(fechaAjustada, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Dashboard Desarrollo Profesional - Tema Oscuro */
/* Avatares */
::v-deep .v-avatar {
  border: 2px solid var(--v-secondary-base);
  transition: all 0.3s ease;
}

::v-deep tr:hover .v-avatar {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
}

/* Iconos */
::v-deep .v-icon {
  transition: all 0.3s ease;
}

::v-deep tr:hover .v-icon {
  transform: scale(1.2);
}

::v-deep .v-icon.success--text {
  color: #26de81 !important;
  filter: drop-shadow(0 2px 8px rgba(38, 222, 129, 0.4));
}

::v-deep .v-icon.error--text {
  color: #fc5c65 !important;
  filter: drop-shadow(0 2px 8px rgba(252, 92, 101, 0.4));
}

/* Text colors */
.text-caption {
  color: #e0e0e0 !important;
}

.success--text {
  color: #26de81 !important;
}

.error--text {
  color: #fc5c65 !important;
}

/* Input fields */
::v-deep .ui-form-field .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.24) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.42) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.5) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .mdi-magnify {
  color: var(--v-secondary-base) !important;
}

::v-deep .no-table-bg.v-data-table,
::v-deep .no-table-bg .v-data-table__wrapper,
::v-deep .no-table-bg table,
::v-deep .no-table-bg tbody,
::v-deep .no-table-bg tr,
::v-deep .no-table-bg td {
  background: transparent !important;
}

::v-deep .no-table-bg thead th {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
  color: #f4f7fb !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.18) !important;
}

::v-deep .no-table-bg tbody tr:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.06) !important;
}

/* Loading */
::v-deep .v-progress-linear {
  border-radius: 8px;
}

::v-deep .v-progress-linear__background {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
  box-shadow: 0 0 12px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.5);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--v-secondary-base);
  border-radius: 4px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  filter: brightness(1.2);
}

.dashboard-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .dashboard-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .dashboard-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
